import { globalClasses } from "helper/globalClasses";
import { globalVariables } from "helper/globalVariables";
import { pendingPayment, successPayment } from "helper/icons";
import { DecoratedPrice } from "helper/utility";
import moment from "moment";
import { useState } from "react";
import Dropdown from "shared/Components/dropdown";
import Loader from "shared/Components/loader";

const PaymentRowComponent = ({ data, index, onChangeStatus }) => {
  const { paginatedDataCls } = globalClasses;

  const {
    id,
    authId,
    owner_name: ownerName,
    registration_name: dogsName,
    call_name,
    email,
    phone_number: phoneNumber,
    dateOfJoining,
    amount,
    payment_status,
  } = data;
  const [statusLoading, setStatusLoading] = useState(false);

  const onChangeStatusInternal = async (id, option) => {
    setStatusLoading(true);
    await onChangeStatus(id, option);
    setStatusLoading(false);
  };

  const renderButton = (paymentStatus, authId) => {
    if (paymentStatus === "Unpaid") {
      return (
        <Dropdown
          width={"w-[150px]"}
          placeholder="Unpaid"
          dropdownOptions={[globalVariables.markAsPaid]}
          customContent="justify-center"
          mainContent="w-100%"
          onChange={(option) => onChangeStatusInternal(authId, option)}
        />
      );
    }

    if (paymentStatus === "Paid") {
      return (
        <div className="flex justify-center border rounded-md py-2 border-[#17B26A] bg-[#F6FEF9] w-[150px]">
          <span className="text-base font-regular text-[#17B26A]">
            {globalVariables.paid}
          </span>
          <img src={successPayment} className="ml-1" alt="" />
        </div>
      );
    } else if (paymentStatus === "Mark as Paid") {
      return (
        <div className="flex justify-center border rounded-md py-2 border-gray-300 bg-white w-[150px]">
          <span className="text-base font-regular text-gray">
            {globalVariables.markAsPaid}
          </span>
          <img src={pendingPayment} className="ml-1" alt="" />
        </div>
      );
    }
  };

  const getValue = (string) => {
    return string?.length > 0 ? string : "NA";
  };

  return (
    <tr key={email}>
      <td className={paginatedDataCls(true)}>{ownerName}</td>
      <td className={paginatedDataCls(true)}>
        {getValue(dogsName ? dogsName : call_name)}
      </td>
      <td className={paginatedDataCls(true)}>{email}</td>
      <td className={paginatedDataCls(true)}>{phoneNumber}</td>
      <td className={paginatedDataCls(true)}>
        {moment(dateOfJoining).format("DD/MM/YYYY")}
      </td>
      <td className={paginatedDataCls(true)}>
        {amount ? DecoratedPrice(amount) : "N/A"}
      </td>
      <td className={paginatedDataCls(true)}>
        {statusLoading ? <Loader /> : renderButton(payment_status, authId)}
      </td>
    </tr>
  );
};

export default PaymentRowComponent;
